import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import ViewModal from "./viewModal";
import DataLoader from "../../Component/Loader/DataLoader";
import { loadVideoData } from "./Slice/newsletterSlice";

function Index() {

  const dispatch = useDispatch();
  const history = useNavigate();
  const { setting } = useSelector((state) => state?.setting);
  const { VideoData } = useSelector((state) => state?.newsletter);
  const { slug } = useParams();
  const [getViewModal, setGetViewModal] = useState(false);
  const [getViewData, setGetViewData] = useState({});
  const params = slug;

  useEffect(() => {
    dispatch(loadVideoData());
  }, [dispatch]);

  const resoucesPages = async (e, name, slug) => {
    e.preventDefault();
    history(`/resource-hub/${slug}`);
  };

  const redirectNewsletter = async (e) => {
    e.preventDefault();
    history("/newsletter");
  };

  const redirectVideos = async (e) => {
    e.preventDefault();
    history("/videos");
  };

  const resoucesDrop = [{
    'name': 'All posts',
    'slug': 'all-posts',
    'value': '0',
    'class': 'fas fa-mail-bulk',
    'key': '0'
  },
  {
    'name': 'People stories',
    'slug': 'people-stories',
    'value': '1',
    'class': 'fas fa-user-clock',
    'key': '1'
  },
  {
    'name': 'Points of view',
    'slug': 'points-of-view',
    'value': '2',
    'class': 'fas fa-street-view',
    'key': '2'
  },
  {
    'name': 'Toolkits',
    'slug': 'toolkits',
    'value': '3',
    'class': 'fas fa-toolbox',
    'key': '3'
  }
  ];

  const siteName = setting?.name?.trim() || "Videos";

  useEffect(() => {
    const title = `${siteName} | Videos`;
    document.title = title;
  }, [siteName]);

  const onViewModal = (e, video_id, title) => {
    e.preventDefault();
    setGetViewModal(true);
    setGetViewData({
      type: 'video',
      title: title,
      item: video_id
    })
  };


  return (
    <div>
      <section className="outer_main">
        <Container className="page_heading text-center">
          <h1>Resources (Videos)</h1>
        </Container>
        <div className="page_content">
          <Container>
            <div className="linkpart linkresorce">
              <ul style={{ border: 'none', backgroundColor:"white" }}>
                {resoucesDrop.map((item, key) => (
                  <li key={item.id} className={(item.slug === params) ? 'linkpart-active' : ''} style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}>
                    <button onClick={(e) => {
                      resoucesPages(e, item.name, item.slug);
                    }} style={{ border: 'none', backgroundColor: 'white' }}>
                      <i className={item.class}></i>
                      <h6>{item.name}</h6>
                    </button>
                  </li>
                ))}

                <li style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}>
                  <button onClick={(e) => {
                    redirectNewsletter(e);
                  }} style={{ border: 'none', backgroundColor:"white" }}>
                    <i className="fas fa-envelope-open-text"></i>
                    <h6>Newsletter</h6>
                  </button>
                </li>

                <li className="linkpart-active" style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}>
                  <button onClick={(e) => {
                    redirectVideos(e);
                  }} style={{ border: 'none' , backgroundColor:"white" }}>
                    <i className="fas fa-video"></i><h6>Videos</h6>
                  </button>
                </li>
              </ul>
            </div>

            <div className="page_content_inner removecol_condition p-0">
              {VideoData &&
                VideoData.length > 0 && (
                  <Row>
                    {VideoData.map((item) =>
                    (
                      <Col md={4} sm={6} className="news-listing video-cols" key={item.id}>
                        <div className="newslleter-cols">
                          <figure>
                            <button className="img-wrapper" onClick={(e) => {
                              onViewModal(e, item.video_id, item.title);
                            }}>
                              <img className="cursor-pointer" src={item.image} alt={item.title} />
                              <i className="far fa-play-circle cursor-pointer"></i>
                            </button>

                            <figcaption>
                              <h4>
                                <button
                                  type="button"
                                  className="video-title-btn"
                                  onClick={(e) => onViewModal(e, item.video_id, item.title)}
                                >
                                  {item.title}
                                </button>
                              </h4>


                              {item.publish_date && (<span className="post-date">Posted on: {item.publish_date}</span>)}
                            </figcaption>
                          </figure>
                        </div>
                      </Col>
                    ))}
                  </Row>
                )}
              {VideoData.length === 0 && (
                <div className="text-center" style={{ textAlign: "center" }}>No data found.</div>
              )}

              {VideoData === true ? <DataLoader /> : null}
            </div>
          </Container>
        </div>
      </section>
      {getViewModal && (
        <ViewModal
          show={getViewModal}
          viewdata={getViewData}
          onHide={() => setGetViewModal(false)}
          centered
          size="xl"
        />
      )}
    </div>
  );
}

export default Index;
